import type { AgenticLogicRuleVersionDto } from "@intelligems/ig-types";
import { IgCodeEditor, IgTypography } from "@intelligems/ig-theme";
import { Stack } from "@mui/material";

/**
 * The expanded version card's body for a template rule: the exact parameters
 * that version froze, read-only.
 *
 * This is what makes two versions of one rule tell apart — the cards are
 * otherwise identical — and it costs no request: the params ride the version
 * list DTO the panel already holds.
 */
export const TemplateVersionConfig = ({
  version,
}: {
  version: AgenticLogicRuleVersionDto | null;
}) => {
  if (version === null) {
    return (
      <IgTypography variant="body2" color="text.secondary">
        This version is no longer available.
      </IgTypography>
    );
  }

  if (version.templateParams === null) {
    return (
      <IgTypography variant="body2" color="text.secondary">
        This version stored no configuration.
      </IgTypography>
    );
  }

  return (
    <Stack spacing={1}>
      <IgCodeEditor
        aria-label={`Configuration published in version ${version.version}`}
        language="json"
        value={JSON.stringify(version.templateParams, null, 2)}
        readOnly
        copy
        lineWrapping={false}
      />
      {version.templateVersion !== null ? (
        <IgTypography variant="caption" color="text.tertiary">
          Template v{version.templateVersion}
        </IgTypography>
      ) : null}
    </Stack>
  );
};
